export default {
  namespaced: true,
  getters: {},
  actions: {},
  mutations: {},
};



// WEBPACK FOOTER //
// ./src/store/modules/career/index.js